import { create } from 'zustand';
import { createAdBlockSlice } from './slices/AdblockSlice';
import { createProductSlice } from './slices/ProductSlice';
import { createOfferSlice } from './slices/OfferSlice';
import { createPageSlice } from './slices/PageSlice';

const useAdBlockStore = create((...a) => ({
    ...createAdBlockSlice(...a),
    ...createProductSlice(...a),
    ...createOfferSlice(...a),
    ...createPageSlice(...a),
    isApproving: false,
    isRejecting: false,
    isDNELoading: false,
}));

export default useAdBlockStore;